import { createGlobalStyle } from 'styled-components';

import MinipaxSemiBoldWoff2 from '../assets/fonts/Minipax-SemiBold.woff2';
import MinipaxSemiBoldWoff from '../assets/fonts/Minipax-SemiBold.woff';
import HarmoniaSansProLightWoff2 from '../assets/fonts/HarmoniaSansPro-Light.woff2';
import HarmoniaSansProLightWoff from '../assets/fonts/HarmoniaSansPro-Light.woff';
import HarmoniaSansProCyrRegularWoff2 from '../assets/fonts/HarmoniaSansProCyr-Regular.woff2';
import HarmoniaSansProCyrRegularWoff from '../assets/fonts/HarmoniaSansProCyr-Regular.woff';
import HarmoniaSansProCyrBoldWoff2 from '../assets/fonts/HarmoniaSansProCyr-Bold.woff2';
import HarmoniaSansProCyrBoldWoff from '../assets/fonts/HarmoniaSansProCyr-Bold.woff';

import Typography from '../components/Typography/Typography';

import { theme } from './theme';

const GlobalStyles = createGlobalStyle`
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  /* html {
    font-size: 125%;
  } */

  img {
    width: 100%;
  }

  @font-face {
    font-family: 'Minipax';
    src: local('Minipax SemiBold'), local('Minipax-SemiBold'), url(${MinipaxSemiBoldWoff2}) format('woff2'),
        url(${MinipaxSemiBoldWoff}) format('woff');
    font-weight: 600;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Harmonia';
    src: local('Harmonia Sans Pro Light'), local('HarmoniaSansPro-Light'), url(${HarmoniaSansProLightWoff2}) format('woff2'),
        url(${HarmoniaSansProLightWoff}) format('woff');
    font-weight: 300;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Harmonia';
    src: local('Harmonia Sans Pro Cyr Regular'), local('HarmoniaSansProCyr-Regular'), url(${HarmoniaSansProCyrRegularWoff2}) format('woff2'),
        url(${HarmoniaSansProCyrRegularWoff}) format('woff');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Harmonia';
    src: local('Harmonia Sans Pro Cyr Bold'), local('HarmoniaSansProCyr-Bold'), url(${HarmoniaSansProCyrBoldWoff2}) format('woff2'),
        url(${HarmoniaSansProCyrBoldWoff}) format('woff');
    font-weight: bold;
    font-style: normal;
    font-display: swap;
  }

  /* Animation styles */
  .zero-opacity {
    opacity: 0;
    transition: opacity 1s ease-in-out;
  }

  .full-opacity {
    opacity: 1;
  }

  /* Fix for last-child border issue - not ideal but it avoids refactoring entire pages and content on production. Sorry, future dev */
  .body {
    overflow-y: hidden;
    .repeating-border-section {
      .bottom-border {
        border-bottom: 1px solid ${theme.colors.black};
      }

      &:last-of-type {
        .bottom-border {
          border-bottom: none;
        }
      }
    }
  }
`;

export default GlobalStyles;
